import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Plugins } from '@capacitor/core';

import { GeoLoc } from '../interfaces/geoloc.model';
import { UserLocationComponent } from '../components/user-location/user-location.component';
import { FirebaseService } from './firebase.service';
import { AuthService } from './auth.service';
import { GoogleMapService } from './google-map.service';

const { Geolocation  } = Plugins;

@Injectable({
  providedIn: 'root'
})
export class GeolocService {
  defaultLocation: GeoLoc;

  // = {
  //   latitude: 38.788538,
  //   longitude: -77.112787
  // };

  constructor(
    private modalController: ModalController,
    private fireSvc: FirebaseService,
    private authSvc: AuthService,
    private gmapSvc: GoogleMapService

    ) { }

  // ** returns current user's geo location */
  async getCurrentLocation(): Promise<GeoLoc> {
    try {
      const location = await Geolocation.getCurrentPosition();
      const zipcode = await this.gmapSvc.getZipcode(location.coords.latitude, location.coords.longitude).toPromise();
      this.defaultLocation = null;
      return {
        latitude: location.coords.latitude,
        longitude: location.coords.longitude,
        zipcode: zipcode
      } as GeoLoc;

    } catch {
      // return default location if access to geolocation is blocked
      if (this.defaultLocation) {
        return this.defaultLocation;
      }

      // request for a location
      await this.getDefaultLocation();
      return this.defaultLocation;
    }
  }




  // ==============================================
  async getDefaultLocation() {
    // Check user profile for zipcode
    const user = await this.authSvc.getUser();
    let userProfile = await this.fireSvc.getUserProfile(user.email).toPromise();
    const location = userProfile.location;
    if(location['zipcode']) {
      console.log('location found on profile')
      this.defaultLocation = {
        latitude: location['latitude'],
        longitude: location['longitude'],
        zipcode: location['zipcode']
      }
    }else {
      const modal = await this.modalController.create({
        component: UserLocationComponent
      });
  
      await modal.present();
      const res = await modal.onDidDismiss();
      this.defaultLocation = res.data;
      userProfile.location = this.defaultLocation;
      await this.fireSvc.saveUserProfile(userProfile);
    }
  }
}
